import React from 'react';
import { TourGuideImage } from '../TourGuideImage';
import image from '../images/image1.png';

export const Segment2 = () => (
    <TourGuideImage src={image} />
);
